// extracted by mini-css-extract-plugin
module.exports = {"menuWrap":"Menu_menuWrap__ll6Jq","opened":"Menu_opened__To73L","menu":"Menu_menu__trOBw","wrap":"Menu_wrap__JptFY"};